// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './Header';
import NavBar from './NavBar';
import Footer from './Footer';
import Home from './Home'; // Make sure to import the Home component
import Forum from './Forum';
import Chat from './Chat';
import Announcements from './Announcements';
import './App.css';

function App() {
  return (
    <Router>
      <div className="sticky-header">
        <Header />
        <NavBar />
      </div>
      <main className="mt-8 mb-8">
        <Routes>
          <Route path="/" element={<Home />} /> {/* Home route */}
          <Route path="/forum" element={<Forum />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/announcements" element={<Announcements />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;
